import { Capacitor } from '@capacitor/core'
import { Device } from '@capacitor/device'
import { LocalStorage } from 'quasar'
import API from 'src/api'
import { http } from '../boot/axios'

const appVersion = import.meta.env.APP_VERSION || 'unknown'
const URL = `${API.GRAPHQL_URL}device-access-log`

const BRAND_PATTERNS = [
  [/zebra|tc\d{2}|mc\d{2}|ec\d{2}|ps\d{2}|wt\d{2}/i, 'Zebra'],
  [/^sm-|samsung/i, 'Samsung'],
  [/honeywell|eda\d|cn\d{2}|ct\d{2}/i, 'Honeywell'],
  [/point.?mobile|^pm\d{2}/i, 'Point Mobile'],
  [/motorola|^moto/i, 'Motorola'],
  [/huawei/i, 'Huawei'],
  [/^lg[-\s]/i, 'LG'],
  [/sony|xperia/i, 'Sony'],
  [/xiaomi|redmi/i, 'Xiaomi'],
  [/^iphone|^ipad|apple/i, 'Apple'],
]

function getOrCreateDeviceId () {
  const key = '_binnacle_device_id'
  let id = LocalStorage.getItem(key)
  if (!id) {
    id = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36)
    LocalStorage.set(key, id)
  }
  return id
}

function getBrand (model) {
  if (model && model !== 'unknown') {
    for (const [pattern, brand] of BRAND_PATTERNS) {
      if (pattern.test(model)) return brand
    }
  }
  return getOrCreateDeviceId()
}

async function collectFromPlugin () {
  try {
    const info = await Device.getInfo()
    return {
      device_name:  info.manufacturer || getBrand(info.model),
      device_model: info.model        || 'unknown',
      app_version:  appVersion,
      os_name:      info.platform     || 'unknown',
      os_version:   info.osVersion    || null
    }
  } catch {
    return null
  }
}

function collectFromUA () {
  const ua = navigator.userAgent
  const isAndroid = /Android/i.test(ua)
  const isIOS = /iPhone|iPad|iPod/i.test(ua)

  let osName = 'unknown'
  let osVersion = null
  let deviceModel = 'unknown'

  if (isAndroid) {
    osName = 'Android'
    const vMatch = ua.match(/Android\s([\d.]+)/)
    osVersion = vMatch ? vMatch[1] : null
    const mMatch = ua.match(/;\s([^;)]+)\sBuild\//)
    deviceModel = mMatch ? mMatch[1].trim() : 'unknown'
  } else if (isIOS) {
    osName = 'iOS'
    const vMatch = ua.match(/OS\s([\d_]+)/)
    osVersion = vMatch ? vMatch[1].replace(/_/g, '.') : null
    deviceModel = /iPad/i.test(ua) ? 'iPad' : 'iPhone'
  }

  return {
    device_name:  getBrand(deviceModel),
    device_model: deviceModel,
    app_version:  appVersion,
    os_name:      osName,
    os_version:   osVersion
  }
}

async function collect () {
  if (!Capacitor.isNativePlatform()) return null
  return (await collectFromPlugin()) || collectFromUA()
}

export default {
  collect,

  async registerAccess () {
    const payload = await collect()
    if (!payload) return null

    return http.post(URL, payload)
      .catch(err => console.error('deviceInfo.registerAccess', err))
  }
}
